import Applied_Roles from 'modules/Applied_Roles/Container/index'
import Dashboard from 'modules/Dashboard/Container/index'
import DriveDetails from 'modules/DriveDetails/Container/index'
import Drives from 'modules/Drives/Container/index'
import ManageProfile from 'modules/ManageProfile/Container/index'
import OfferLetter from 'modules/OfferLetter/Container/index'
import OfferAccept from 'modules/OfferLetter/Style/OfferAccpect'
import OfferUploadDocument from 'modules/OfferLetter/Style/OfferUploadDocument'
import Resume from 'modules/Resume/Container/index'
import Roles from 'modules/Roles/Container/index'
import ViewRole from 'modules/ViewRole/Container/index'
import ViewSingleRole from 'modules/ViewSingleRole/Container/index'
import PageNotFound from 'routes/Components/PageNotFound'
//components for activation of student account
import FinalPage from 'modules/Onboarding/Components/ActivateAccount/FinalPage/FinalPage'
import ActivateStudent from 'modules/Onboarding/Container/activateContainer'

//components for not interested pages
import FinalPageNI from 'modules/Onboarding/Components/NotInterested/FinalPage/FinalPageNI'
import NotIntrested from 'modules/Onboarding/Components/NotInterested/NotIntrested/NotIntrested'

import Events from 'modules/Events/Container/index.js'
import Register from 'modules/Onboarding/Container/registerContainer'
import Notification from 'modules/Onboarding/Register/Notification/Notification'
import FailScreen from 'modules/Roles/Questionnaire/ConfirmationScreens/FailScreen'
import ResultScreen from 'modules/Roles/Questionnaire/ConfirmationScreens/ResultScreen'
import Questionnaire from 'modules/Roles/Questionnaire/Container/index'
import Feedback from 'modules/Roles/Questionnaire/Feedback/Container/index'
import Assessment from 'modules/Assessments/Container/index'

export const anonymous = [
  {
    routePath: '/onboarding/activate/:studentId',
    Component: ActivateStudent,
  },
  {
    routePath: '/not-interested/:studentId',
    Component: NotIntrested,
  },
  {
    routePath: '/not-interested/final/:studentId',
    Component: FinalPageNI,
  },
  {
    routePath: '*',
    Component: PageNotFound,
  },
]

export const authenticated = [
  {
    routePath: '/dashboard',
    Component: Dashboard,
  },
  // {
  //   routePath: '/assessment',
  //   Component: Assessment,
  // },
  // {
  //   routePath: '/assessment/behavioral',
  //   Component: Instructions,
  // },
  // {
  //   routePath: '/assessment/communication',
  //   Component: CommunicationInstructions,
  // },
  {
    routePath: '/roles',
    Component: Roles,
  },
  {
    routePath: 'appliedroles/viewrole/:CorpID/:JobID',
    Component: ViewRole,
  },
  {
    routePath: 'roles/viewrole/:CorpID/:JobID',
    Component: ViewSingleRole,
  },
  {
    routePath: 'roles/viewrole/:CorpID/:JobID/questionnaire',
    Component: Questionnaire,
  },
  {
    routePath: 'roles/viewrole/:CorpID/:JobID/questionnaire/feedback',
    Component: Feedback,
  },
  {
    routePath: 'roles/questionnaire/:CorpID/:JobID/job/result',
    Component: ResultScreen,
  },
  {
    routePath: '/roles/questionnaire/:CorpID/:JobID/job/re-applied',
    Component: FailScreen,
  },
  {
    routePath: '/resume',
    Component: Resume,
  },
  {
    routePath: '/applied_roles/:Status',
    Component: Applied_Roles,
  },
  {
    routePath: '/applied_roles',
    Component: Applied_Roles,
  },
  {
    routePath: '/drives',
    Component: Drives,
  },
  {
    routePath: '/manageprofile',
    Component: ManageProfile,
  },
  {
    routePath: '/driveDetails/:RoleID/:DriveID',
    Component: DriveDetails,
  },
  {
    routePath: '/offerReceived',
    Component: OfferLetter,
  },
  {
    routePath: '/offerReceived/:Status',
    Component: OfferLetter,
  },
  {
    routePath: '/offerReceived/ExCand/:offerID',
    Component: OfferAccept,
  },
  {
    routePath: '/offerReceived/uploadDocument/:offerID',
    Component: OfferUploadDocument,
  },
  {
    routePath: '/onboarding/final/:studentId',
    Component: FinalPage,
  },
  {
    routePath: '/onboarding/register/:studentId',
    Component: Register,
  },
  {
    routePath: '/onboarding/notification/:studentId',
    Component: Notification,
  },
  {
    routePath: '/events',
    Component: Events,
  },
  {
    routePath: '/',
    Component: Dashboard,
  },
  {
    routePath: '*',
    Component: Dashboard,
  },
]
